/**
 * VerticalNav Component for UI-Model-1
 *
 * Vertical navigation bar with Layout/CSS/Theme tabs
 */

import React from 'react';
import { useVerticalNav } from '../../contexts/VerticalNavContext';
import { VerticalTabType } from '../../types/navigation.types';
import { TabButton } from '../TabButton/TabButton';
import { CustomCssIcon, LayoutUIModelIcon, ThemeIcon } from 'assests/GmsIcons';

interface VerticalNavProps {
  id?: string;
}

const TABS = [
  {
    id: 'layout' as VerticalTabType,
    label: 'Layout',
    icon: <LayoutUIModelIcon />,
  },
  {
    id: 'css' as VerticalTabType,
    label: 'Custom CSS',
    icon: <CustomCssIcon />,
  },
  {
    id: 'theme' as VerticalTabType,
    label: 'Theme',
    icon: <ThemeIcon />,
  },
];

export const VerticalNav = ({ id }: VerticalNavProps) => {
  const baseId = id || 'vertical-nav';
  const { activeTab, setActiveTab } = useVerticalNav();

  return (
    <div
      id={baseId}
      data-testid={baseId}
      className="tw-flex tw-flex-col tw-w-16 tw-bg-surface tw-mt-1.5 tw-border-r tw-border-edge"
    >
      {TABS.map((tab) => (
        <TabButton
          key={tab.id}
          id={`${baseId}-tab-${tab.id}`}
          icon={tab.icon}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={() => setActiveTab(tab.id)}
        />
      ))}
    </div>
  );
};

export default VerticalNav;
